import { render, staticRenderFns } from "./EditImageField.vue?vue&type=template&id=b950608e&scoped=true&"
import script from "./EditImageField.vue?vue&type=script&lang=js&"
export * from "./EditImageField.vue?vue&type=script&lang=js&"
import style0 from "./EditImageField.vue?vue&type=style&index=0&id=b950608e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b950608e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b950608e')) {
      api.createRecord('b950608e', component.options)
    } else {
      api.reload('b950608e', component.options)
    }
    module.hot.accept("./EditImageField.vue?vue&type=template&id=b950608e&scoped=true&", function () {
      api.rerender('b950608e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditImageField.vue"
export default component.exports